import { AppState } from '@/types';
import { PledgeBasedTarget } from '@/types/pledgeBasedPlan';

export const createPledgeBasedPetActions = (state: AppState, dispatch: any) => {
  const linkPetToPledgeSheet = (pledgeSheetId: string) => {
    dispatch({ type: 'LINK_PET_TO_PLEDGE_SHEET', payload: { pledgeSheetId } });
  };

  const updatePetWithDailyPerformance = (weeklyTargets: PledgeBasedTarget) => {
    dispatch({ type: 'UPDATE_PET_DAILY_PERFORMANCE', payload: { weeklyTargets } });
  };

  const processWeeklyPetSettlement = (weeklyTargets: PledgeBasedTarget) => {
    dispatch({ type: 'PROCESS_WEEKLY_PET_SETTLEMENT', payload: { weeklyTargets } });
  };

  const checkPetDailyUpdate = (weeklyTargets: PledgeBasedTarget) => {
    dispatch({ type: 'CHECK_PET_DAILY_UPDATE', payload: { weeklyTargets } });
  };

  return {
    linkPetToPledgeSheet,
    updatePetWithDailyPerformance,
    processWeeklyPetSettlement,
    checkPetDailyUpdate
  };
};